<template>
  <div class="page flex-col animate__animated animate__fadeInUp">
    <div class="bd1 flex-col">
      <div class="layer6 flex-row justify-between">
        <!-- <div class="box1 flex-col">
          <div class="outer1 flex-col">
            <div class="main1 flex-col">
              <span class="word5">传统分类</span>
            </div>
            <div class="main2 flex-row justify-between">
              <span class="word6">全部</span> <span class="word7">（989）</span>
            </div>
            <div class="flex-col">
              <span class="mytree">
                <el-tree
                  :data="treeData"
                  :load="loadNode"
                  :render-content="renderContent"
                  ref="tree"
                  node-key="id"
                  @node-click="handleNodeClick"
                >
                </el-tree>
              </span>
            </div>
          </div>
        </div> -->
        <div class="box3 flex-col">
          <div class="main10 flex-col">
            <div class="mod3search flex-row align-center">
              <!-- <span class="word20search">搜索：</span>
              <div class="flex-row align-center">
                <el-input
                  v-model="inputKey"
                  class="txtsearch"
                  placeholder="请输入搜索内容"
                ></el-input>
                <el-button class="btnsearch" @click="essearch()"
                  >搜索</el-button
                >
              </div> -->
              <div class="box4 pagetop">
                <div class="searchbox" style="width: 120px; text-align: center">
                  <el-popover placement="right" width="400" trigger="click">
                    <el-input
                      placeholder="書名關鍵字"
                      v-model="inputKey"
                      @keyup.enter.native="keySearch"
                    >
                      <i
                        slot="prefix"
                        style="cursor: pointer"
                        class="el-input__icon el-icon-search"
                        @click="keySearch"
                      ></i
                    ></el-input>
                    <img
                      slot="reference"
                      src="/static/icon/search.jpg"
                      alt=""
                    />
                  </el-popover>
                  <span class="word20search">分類瀏覽</span>
                </div>
                <div class="flexclass">
                  <el-tag
                    v-for="(tag, tindex) in filterData"
                    :size="tag.isChild ? 'small' : 'medium'"
                    :key="tindex"
                    closable
                    type="danger"
                    @close="handleClose(tindex, tag)"
                  >
                    >
                    {{ tag.dictLabel }}
                  </el-tag>
                  <el-button
                    v-show="filterData.length > 0"
                    type="text"
                    icon="el-icon-delete"
                    class="btnclear"
                    @click="filterClear()"
                    >清空</el-button
                  >
                </div>
              </div>
            </div>
            <!-- <div class="mod30 flex-row">
              <span class="word20">范围搜索</span>
              <div class="line"></div>
              <div
                class="flex-row"
                style="
                  width: 22rem;
                  overflow: hidden;
                  flex-wrap: wrap;
                  margin-left: 10px;
                "
              >
                <div
                  v-for="(fw, index) in fwList"
                  :key="index"
                  @click="filterSearch('fw', fw.name, fw.name, fw, index)"
                  style="margin-right: 0.614rem"
                  class="flex-col justify-center justify-center"
                >
                  <div
                    class="itembutton"
                    :class="{
                      itembutton: !fw.classClick,
                      itembuttonclick: fw.classClick,
                    }"
                  >
                    {{ fw.name }}
                  </div>
                </div>
              </div>
            </div> -->
            <div class="searchtype">
              <div class="box4">
                <div class="mod30 flex-row">
                  <span class="word20">
                    <span>版本類別一</span>
                  </span>
                  <div class="line"></div>

                  <div
                    class="flex-row"
                    style="
                      flex: 1;
                      overflow: hidden;
                      flex-wrap: wrap;
                      margin-left: 10px;
                      position: relative;
                    "
                  >
                    <!-- <div
                      style="margin-right: 0.614rem"
                      :class="'flex-col justify-center lineabsolute'"
                    >
                      <div
                        :class="{
                          itembutton: versionTypeFilterData.length > 0,
                          itembuttonclick: versionTypeFilterData.length < 1,
                        }"
                      >
                        全部
                      </div>
                    </div> -->
                    <div
                      v-for="(versionType, index) in versionTypeData"
                      :key="versionType.value"
                      style="margin-right: 0.614rem"
                      class="flex-col justify-center"
                    >
                      <div
                        class="itembutton"
                        :class="{
                          itembutton:
                            versionTypeFilterData.indexOf(versionType.value) <
                            0,
                          itembuttonclick:
                            versionTypeFilterData.indexOf(versionType.value) >
                            -1,
                        }"
                        @click.stop="
                          filterSearch(
                            'versionType',
                            versionType.value,
                            versionType.label,
                            versionType,
                            index
                          )
                        "
                      >
                        <span>{{ versionType.label }}</span>
                        <!-- <div
                          v-for="(child, index1) in versionType.children"
                          :key="child.id"
                          class="childbutton"
                        >
                          <span v-if="index1 == 0">(</span
                          ><span>{{ child.label }}</span
                          ><span
                            v-if="index1 + 1 == versionType.children.length"
                            >)</span
                          >
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="mod30 flex-row"
                  v-show="versionTypeFilterData.length > 0"
                >
                  <div
                    class="flex-row"
                    style="
                      flex: 1;
                      overflow: hidden;
                      flex-wrap: wrap;
                      margin-left: 10px;
                      padding-left: 87px;
                    "
                  >
                    <!-- v-for="(v11, i11) in versionTypeData11"
                      :key="v11.id" -->
                    <div
                      v-for="(vversionType, vindex) in versionTypeData"
                      :key="vversionType.id"
                      :style="{
                        display: 'flex',
                        marginLeft:
                          vindex == 0 ? vindex - 1 * 50 + 110 + 'px' : '0px',
                      }"
                    >
                      <div
                        style="margin-right: 22px"
                        class="flex-col justify-center justify-center"
                        v-show="
                          versionTypeFilterData.indexOf(vversionType.id) > -1
                        "
                        v-for="(v11, i11) in vversionType.children"
                        :key="v11.id"
                      >
                        <div
                          :class="{
                            itembutton:
                              versionTypeFilterData.indexOf(v11.id) < 0,
                            itembuttonclick:
                              versionTypeFilterData.indexOf(v11.id) > -1,
                            secondTitle: true,
                          }"
                          @click="
                            filterSearch(
                              'versionType11',
                              v11.id,
                              v11.label,
                              v11,
                              i11
                            )
                          "
                        >
                          {{ v11.label }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mod30 flex-row">
                  <span class="word20">
                    <span>版本類別二</span>
                  </span>
                  <div class="line"></div>
                  <div
                    class="flex-row"
                    style="
                      flex: 1;
                      overflow: hidden;
                      flex-wrap: wrap;
                      margin-left: 10px;
                    "
                  >
                    <div
                      v-for="(versionType1, index1) in versionTypeData1"
                      :key="versionType1.value"
                      style="margin-right: 0.614rem"
                      class="flex-col justify-center justify-center"
                    >
                      <div
                        class="itembutton"
                        @click="
                          filterSearch(
                            'versionType1',
                            versionType1.value,
                            versionType1.label,
                            versionType1,
                            index1
                          )
                        "
                        :class="{
                          itembutton:
                            versionTypeFilterData.indexOf(versionType1.value) <
                            0,
                          itembuttonclick:
                            versionTypeFilterData.indexOf(versionType1.value) >
                            -1,
                        }"
                      >
                        <span>{{ versionType1.label }}</span>
                        <div
                          v-for="(child, index) in versionType1.children"
                          :key="child.id"
                          class="childbutton"
                        >
                          <span v-if="index == 0">(</span
                          ><span>{{ child.label }}</span
                          ><span
                            v-if="index + 1 == versionType1.children.length"
                            >)</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mod30 flex-row">
                  <span class="word20">
                    <span>四</span>
                    <span>部</span>
                  </span>
                  <div class="line"></div>
                  <div
                    class="flex-row"
                    style="
                      flex: 1;
                      overflow: hidden;
                      flex-wrap: wrap;
                      margin-left: 10px;
                    "
                  >
                    <!-- <div
                      style="margin-right: 0.614rem"
                      :class="'flex-col justify-center lineabsolute'"
                    >
                      <div
                        :class="{
                          itembutton: categoryFilterData.length > 0,
                          itembuttonclick: categoryFilterData.length < 1,
                        }"
                      >
                        全部
                      </div>
                    </div> -->

                    <div
                      v-for="(category, index) in categoryData"
                      :key="index"
                      style="margin-right: 0.614rem"
                      class="flex-col justify-center"
                    >
                      <div
                        :class="{
                          itembutton:
                            categoryFilterData.indexOf(category.id) < 0,
                          itembuttonclick:
                            categoryFilterData.indexOf(category.id) > -1,
                        }"
                        @click="
                          filterSearch(
                            'category',
                            category.id,
                            category.name,
                            category,
                            index
                          )
                        "
                      >
                        {{ category.name }}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="mod30 flex-row"
                  v-show="categoryFilterData.length > 0"
                  v-for="(c1, i1) in categoryData"
                  :key="'c1' + i1"
                >
                  <!-- <span class="word20">
                    <span></span><span>类</span><span></span>
                  </span> -->
                  <!-- <div class="line"></div> -->
                  <div
                    class="flex-row"
                    style="
                      flex: 1;
                      overflow: hidden;
                      flex-wrap: wrap;
                      margin-left: 10px;
                      padding-left: 87px;
                    "
                  >
                    <div
                      style="margin-right: 0.614rem"
                      class="flex-col justify-center justify-center"
                      v-show="categoryFilterData.indexOf(c1.id) > -1"
                      v-for="(category1, index1) in c1.children"
                      :key="category1.id"
                    >
                      <div
                        :class="{
                          itembutton:
                            categoryFilterData.indexOf(category1.id) < 0,
                          itembuttonclick:
                            categoryFilterData.indexOf(category1.id) > -1,
                          secondTitle: true,
                        }"
                        @click="
                          filterSearch(
                            'category1',
                            category1.id,
                            category1.name,
                            category1,
                            index1,
                            category1.parentId
                          )
                        "
                      >
                        {{ category1.name }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mod30 flex-row">
                  <span class="word20">
                    <span>刊</span>
                    <span>钞</span>
                    <span>人</span>
                  </span>
                  <div class="line"></div>
                  <div
                    class="flex-row"
                    style="
                      flex: 1;
                      overflow: hidden;
                      flex-wrap: wrap;
                      margin-left: 10px;
                    "
                  >
                    <!-- <div
                      style="margin-right: 0.614rem"
                      :class="'flex-col justify-center lineabsolute'"
                    >
                      <div
                        :class="{
                          itembutton: vcopierFilterData.length > 0,
                          itembuttonclick: vcopierFilterData.length < 1,
                        }"
                      >
                        全部
                      </div>
                    </div> -->
                    <div
                      style="margin-right: 0.614rem"
                      class="flex-col justify-center"
                      v-for="(vcopier, index) in vcopierData"
                      :key="vcopier.value"
                    >
                      <div
                        :class="{
                          itembutton:
                            vcopierFilterData.indexOf(vcopier.value) < 0,
                          itembuttonclick:
                            vcopierFilterData.indexOf(vcopier.value) > -1,
                        }"
                        @click="
                          filterSearch(
                            'vcopier',
                            vcopier.value,
                            vcopier.label,
                            vcopier,
                            index
                          )
                        "
                      >
                        {{ vcopier.label }}
                        <!-- <div
                          v-for="(child, index) in vcopier.children"
                          :key="child.id"
                          class="childbutton"
                        >
                          <span v-if="index == 0">(</span>{{ child.label
                          }}<span v-if="index + 1 == vcopier.children.length"
                            >)</span
                          >
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="mod30 flex-row"
                  v-show="vcopierFilterData.length > 0"
                >
                  <div
                    class="flex-row"
                    style="
                      flex: 1;
                      overflow: hidden;
                      flex-wrap: wrap;
                      margin-left: 10px;
                      padding-left: 87px;
                    "
                  >
                    <div
                      style="margin-right: 0.614rem"
                      class="flex-col justify-center justify-center"
                      v-for="(v11, i11) in vcopierData1"
                      :key="v11.id"
                    >
                      <div
                        :class="{
                          itembutton: vcopierFilterData.indexOf(v11.id) < 0,
                          itembuttonclick:
                            vcopierFilterData.indexOf(v11.id) > -1,
                          secondTitle: true,
                        }"
                        @click="
                          filterSearch('vcopier1', v11.id, v11.label, v11, i11)
                        "
                      >
                        {{ v11.label }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mod30 flex-row">
                  <span class="word20">
                    <span>國</span>
                    <span>别</span>
                  </span>
                  <div class="line"></div>
                  <div
                    class="flex-row"
                    style="
                      width: 100%;
                      overflow: hidden;
                      flex-wrap: wrap;
                      margin-left: 10px;
                    "
                  >
                    <!-- <div
                      style="margin-right: 0.614rem"
                      :class="'flex-col justify-center lineabsolute'"
                    >
                      <div
                        :class="{
                          itembutton: countryTypeFilterData.length > 0,
                          itembuttonclick: countryTypeFilterData.length < 1,
                        }"
                      >
                        全部
                      </div>
                    </div> -->

                    <div
                      style="margin-right: 0.614rem"
                      :class="
                        countryType.dictValue == -1
                          ? 'flex-col justify-center lineabsolute'
                          : 'flex-col justify-center'
                      "
                      v-for="(countryType, index) in countryTypeData"
                      :key="countryType.dictValue"
                    >
                      <div
                        :class="{
                          itembutton:
                            countryTypeFilterData.indexOf(
                              countryType.dictValue
                            ) < 0,
                          itembuttonclick:
                            countryTypeFilterData.indexOf(
                              countryType.dictValue
                            ) > -1,
                        }"
                        @click="
                          filterSearch(
                            'countryType',
                            countryType.dictValue,
                            countryType.dictLabel,
                            countryType,
                            index
                          )
                        "
                      >
                        {{ countryType.dictLabel }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mod30 flex-row">
                  <span class="word20">刊钞&nbsp;年代</span>
                  <div class="line"></div>
                  <div
                    class="flex-row"
                    style="
                      flex: 1;
                      overflow: hidden;
                      flex-wrap: wrap;
                      margin-left: 10px;
                    "
                  >
                    <!-- <div
                      style="margin-right: 0.614rem"
                      :class="'flex-col justify-center lineabsolute'"
                    >
                      <div
                        :class="{
                          itembutton: dynastyTypeFilterData.length > 0,
                          itembuttonclick: dynastyTypeFilterData.length < 1,
                        }"
                      >
                        全部
                      </div>
                    </div> -->

                    <div
                      v-for="(dynastyType, index) in dynastyTypeData"
                      :key="dynastyType.dictValue"
                      style="margin-right: 0.614rem"
                      class="flex-col justify-center"
                    >
                      <div
                        :class="{
                          itembutton:
                            dynastyTypeFilterData.indexOf(
                              dynastyType.dictValue
                            ) < 0,
                          itembuttonclick:
                            dynastyTypeFilterData.indexOf(
                              dynastyType.dictValue
                            ) > -1,
                        }"
                        @click="
                          filterSearch(
                            'dynastyType',
                            dynastyType.dictValue,
                            dynastyType.dictLabel,
                            dynastyType,
                            index
                          )
                        "
                      >
                        {{ dynastyType.dictLabel }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="mod7 flex-col"></div> -->
            </div>
            <!-- <div class="mod8 flex-row align-center" style="z-index: 1000">
              <span class="word32">已选条件</span>
              <div
                class="flex-row left"
                style="
                  width: 20rem;
                  overflow: hidden;
                  flex-wrap: wrap;
                  margin-bottom: 10px;
                "
              >
                <template v-for="(filterd, index) in filterData">
                  <div class="bd2 flex-col">
                    <div class="main11 flex-row justify-between">
                      <span class="word33">{{ filterd.dictLabel }}</span>
                      <div class="group1 flex-col">
                        <img
                          class="label2"
                          referrerpolicy="no-referrer"
                          src="@/assets/img/icon_res_colse.png"
                          @click="
                            filterMover(
                              filterd.searchType,
                              filterd.dictValue,
                              filterd.dictLabel,
                              index
                            )
                          "
                        />
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <div class="flex-row right">
                <el-button
                  type="text"
                  icon="el-icon-delete"
                  class="btnclear"
                  @click="filterClear()"
                  >清空</el-button
                >
              </div>
            </div> -->
          </div>

          <div class="bd3 flex-col">
            <div class="flex-col" style="width: 100%">
              <div class="box21 box4">
                <span class="txt18">{{ totalNum }}</span>
                <span class="word60">&nbsp;条结果</span>
                <!-- 每页显示 -->
                <!-- <span class="info24">{{ pageSize }}</span>
                <span class="word61">&nbsp;条</span> -->
                <img
                  v-if="!grid"
                  @click="qhGrid()"
                  style="width: 20px; height: 20px; margin-left: 10px"
                  src="../../static/home/grid.png"
                />
                <img
                  v-if="grid"
                  @click="qhGrid()"
                  style="width: 20px; height: 20px; margin-left: 10px"
                  src="../../static/home/no_grid.png"
                />
              </div>
              <div
                class="contentbox"
                v-infinite-scroll="newload"
                infinite-scroll-disabled="newdisabled"
                infinite-scroll-distance="10"
              >
                <div class="layer10 flex-row box4">
                  <template v-for="bookdata in bookSearchData">
                    <div
                      class="main12"
                      :style="{
                        padding: grid ? '0px 0px 10px 0px' : '10px',
                        width: grid ? '7.4667rem' : '100%',
                        marginLeft: grid ? '0.4rem' : '0px',
                        marginBottom: grid ? '0.4rem' : '0.294rem',
                      }"
                    >
                      <div
                        class="box5 flex-col"
                        :class="{
                          'flex-col': grid,
                          'flex-row': !grid,
                        }"
                      >
                        <div
                          class="bd4 flex-col"
                          :style="{ display: grid ? 'block' : 'none' }"
                          @click="gotoview(bookdata.bookId, 1)"
                        >
                          <!-- <el-image
                          ref="lazyImg"
                          style="height: 8.96rem; width: 7.4667rem"
                          :src="url + bookdata.coverImageUrl"
                        >
                        </el-image> -->
                          <img
                            :src="url + bookdata.coverImageUrl"
                            style="
                              height: 200px;
                              width: 280px;
                              object-fit: contain;
                              cursor: pointer;
                            "
                            alt=""
                          />
                        </div>
                        <div
                          class="flex-col"
                          :style="{
                            padding: grid ? '0.4rem 16px 0' : '0.1rem 16px',
                          }"
                        >
                          <span class="word34"
                            ><span
                              style="cursor: pointer"
                              @click="gotoview(bookdata.bookId, 1)"
                              >{{ bookdata.bookName }}</span
                            ></span
                          >
                          <div
                            :style="{ display: !grid ? 'flex' : '' }"
                            class="cursornwresize"
                          >
                            <div
                              :style="{
                                marginRight: !grid ? '30px' : '',
                              }"
                            >
                              <p class="txt13">
                                <span
                                  class="tex131"
                                  :style="{
                                    width: grid ? '20%' : '',
                                  }"
                                  >題名：</span
                                >
                                <span
                                  :style="{
                                    width: grid ? '80%' : '',
                                  }"
                                  class="tex132"
                                  :title="
                                    bookdata.titleName &&
                                    bookdata.titleName.length > 15
                                      ? bookdata.titleName
                                      : ''
                                  "
                                >
                                  {{ bookdata.titleName }}
                                </span>
                              </p>
                            </div>
                            <div
                              :style="{
                                marginRight: !grid ? '30px' : '',
                              }"
                            >
                              <p class="txt13">
                                <span
                                  class="tex131"
                                  :style="{
                                    width: grid ? '20%' : '',
                                  }"
                                  >分類：</span
                                >
                                <span
                                  :style="{
                                    width: grid ? '80%' : '',
                                  }"
                                  class="tex132"
                                >
                                  {{ bookdata.categoryName }}
                                </span>
                              </p>
                            </div>
                            <div
                              :style="{
                                marginRight: !grid ? '30px' : '',
                              }"
                            >
                              <p class="txt13">
                                <span
                                  class="tex131"
                                  :style="{
                                    width: grid ? '20%' : '',
                                  }"
                                  >作者：</span
                                >
                                <span
                                  :style="{
                                    width: grid ? '80%' : '',
                                  }"
                                  class="tex132"
                                  :title="
                                    bookdata.charger &&
                                    bookdata.charger.length > 15
                                      ? bookdata.charger
                                      : ''
                                  "
                                >
                                  {{ bookdata.charger }}
                                </span>
                              </p>
                            </div>
                            <div
                              :style="{
                                marginRight: !grid ? '30px' : '',
                              }"
                            >
                              <p class="txt13">
                                <span
                                  class="tex131"
                                  :style="{
                                    width: grid ? '20%' : '',
                                  }"
                                  >版本：</span
                                ><span
                                  :title="
                                    bookdata.bookVersion &&
                                    bookdata.bookVersion.length > 15
                                      ? bookdata.bookVersion
                                      : ''
                                  "
                                  class="tex132"
                                  :style="{
                                    width: grid ? '80%' : '',
                                  }"
                                  >{{ bookdata.bookVersion }}</span
                                >
                              </p>
                            </div>

                            <div
                              :style="{
                                marginRight: !grid ? '30px' : '',
                              }"
                            >
                              <p class="txt13">
                                <span
                                  class="tex131"
                                  :style="{
                                    width: grid ? '20%' : '',
                                  }"
                                  >函冊：</span
                                >
                                <span
                                  :style="{
                                    width: grid ? '80%' : '',
                                  }"
                                  class="tex132"
                                  v-text="bookdata.han"
                                >
                                </span>
                                <!-- v-text="
                                    bookdata.han
                                      ? bookdata.volume
                                        ? bookdata.han +
                                          '函' +
                                          bookdata.volume +
                                          '冊'
                                        : bookdata.han + '函'
                                      : bookdata.volume
                                      ? bookdata.volume + '冊'
                                      : ''
                                  " -->
                              </p>
                            </div>
                          </div>
                          <!-- <span
                          v-if="!grid && fwFilterData.indexOf('全文') !== -1"
                          class="txt13"
                          style="
                            width: 600px;
                            line-clamp: 2;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                          "
                          >全文检索：<span v-html="bookdata.pageText"></span>
                        </span> -->

                          <div
                            :class="
                              grid
                                ? 'bd5 flex-row align-center'
                                : 'bd55 flex-row align-center'
                            "
                          >
                            <div
                              class="btngoto"
                              @click="gotodeatail(bookdata.bookId, 1)"
                            >
                              詳情
                            </div>
                            <!-- <div class="section4 flex-col"></div> -->
                            <!-- <el-popover
                            placement="bottom"
                            width="200"
                            trigger="hover"
                            content="阅读量"
                          >
                            <div
                              class="box6 box66 flex-col"
                              slot="reference"
                              style="margin-left: 8px"
                            >
                              <span class="gnstyle">阅读量</span>
                            </div>
                          </el-popover> -->

                            <el-popover
                              placement="right"
                              trigger="click"
                              :append-to-body="false"
                            >
                              <!-- <share
                                :vshareConfig="{
                                  title: bookdata.bookName,
                                  url:
                                    fxUrl + `#/detail?id=${bookdata.id}&page=1`,
                                  summary: bookdata.charger,
                                  pic: url + bookdata.coverImageUrl,
                                }"
                              >
                              </share> -->
                              <div class="sellianjie">
                                <el-popover
                                  trigger="click"
                                  class="item"
                                  effect="light"
                                  placement="bottom"
                                  :visible-arrow="false"
                                  style="margin-right: 10px"
                                  :append-to-body="false"
                                >
                                  <p
                                    v-html="sharetip"
                                    style="text-align: center"
                                  ></p>
                                  <img
                                    slot="reference"
                                    src="/static/icon/href.png"
                                    alt=""
                                    style="
                                      cursor: pointer;
                                      width: 24px;
                                      height: 24px;
                                    "
                                    @click="
                                      getShareHref(
                                        bookdata.bookName,
                                        bookdata.bookId,
                                        1
                                      )
                                    "
                                  />
                                </el-popover>
                                <el-popover
                                  class="item"
                                  effect="light"
                                  :visible-arrow="false"
                                  placement="bottom"
                                  trigger="click"
                                  :append-to-body="false"
                                >
                                  <p
                                    v-html="sharetip"
                                    style="text-align: center"
                                  ></p>
                                  <img
                                    slot="reference"
                                    src="/static/icon/weixin.png"
                                    style="
                                      cursor: pointer;
                                      width: 24px;
                                      height: 24px;
                                    "
                                    alt=""
                                    @click="
                                      getShareHref(
                                        bookdata.bookName,
                                        bookdata.bookId,
                                        1
                                      )
                                    "
                                  />
                                </el-popover>
                              </div>
                              <div
                                class="box6 flex-col"
                                slot="reference"
                                style="margin-left: 8px"
                              >
                                <span class="gnstyle">轉發</span>
                              </div>
                            </el-popover>

                            <div
                              class="flex-row align-center menu_item cursorpointer"
                              @click="
                                clickMenu(bookdata.bookId, bookdata.favorId)
                              "
                              style="margin-left: 8px"
                            >
                              <img
                                style="width: 18px"
                                :src="
                                  bookdata.favorId
                                    ? require('@/assets/detail/sc1.png')
                                    : require('@/assets/detail/sc.png')
                                "
                              />
                              <span class="gnstyle">{{
                                bookdata.favorId ? "取消收藏" : "收藏"
                              }}</span>
                            </div>
                            <div
                              class="box66 flex-col"
                              slot="reference"
                              style="margin-left: 8px"
                            >
                              <span class="gnstyle" style="margin-left: 18px">{{
                                bookdata.readNum
                              }}</span>
                            </div>
                            <!-- <div class="section6 flex-col align-center" style="margin-left: 6px;">
                        <div class="wrap1 flex-col"></div>
                      </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
                <div style="margin: 10px 0">
                  <p style="text-align: center" v-if="newloading">加载中...</p>
                  <p style="text-align: center" v-if="noMore">沒有更多内容了</p>
                </div>
              </div>

              <!-- <div
                class="layer25 flex-row justify-center"
                v-if="bookSearchData && bookSearchData.length > 0"
              >
                <el-pagination
                  @current-change="currentChange"
                  layout="prev, pager, next"
                  :total="totalNum"
                >
                </el-pagination>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <!-- <img
        :style="{
          marginTop: bookSearchData.length === 0 ? '2rem' : '',
        }"
        class="img1"
        referrerpolicy="no-referrer"
        src="@/assets/img/icon_res_bg.png"
      /> -->
    </div>
  </div>
</template>
<script>
import {
  smsCode,
  smsLogin,
  booksTree,
  getDictType,
  getDictTypeTree,
  getDynastyJapan,
  essearch,

  categoryTree
} from '@/api/api'
import {
  bookList,
  bookListUser

} from '@/api'
import {
  favorAdd,
  // isFavor,
  deleteFavor
} from '@/api/favor'
// import $ from 'jquery'

export default {
  data () {

    return {
      visible: false,
      sharetip: "",//分享提示
      newloading: false, //滚动加载
      fxUrl: window.location.href.split('#')[0],
      vshareConfig: {
        shareList: [
          // 此处放分享列表（ID）
          'qzone'
        ],
        common: {
          bdText: '212',
          bdUrl: 'baidu'
          //此处放置通用设置
        },
        share: [{
          //此处放置分享按钮设置
        }],
        slide: [
          //此处放置浮窗分享设置
        ],
        image: [
          //此处放置图片分享设置
        ],
        selectShare: [
          //此处放置划词分享设置
        ]
      },
      isFavor: false,
      url: window.__baseUrl__,
      fw: '', //范围搜索
      versionType: '', //版本
      category: '', //四部
      vcopier: '', //赶抄人
      countryType: '', //国别
      dynastyType: '', //刊钞年代
      list: [], //已选数组
      constants: {},
      token: '',
      inputKey: '',
      parentId: 0,
      nodeType: 'category',
      treeData: [],
      fwFilterData: [],
      fwList: [{
        name: '全部',
        classClick: true
      }, {
        name: '书名',
        classClick: false
      }, {
        name: '全文',
        classClick: false
      }
        // ,{
        //  name: '目录',
        //  classClick:false
        // }
        , {
        name: '介绍',
        classClick: false
      }, {
        name: '作者',
        classClick: false
      }
      ],
      versionTypeData: [],
      versionTypeData1: [],//版本类型二
      versionTypeData11: [],//版本子类
      categoryData: [],
      categoryLeiData: [],
      vcopierData: [],
      vcopierData1: [],//子
      countryTypeData: [],
      dynastyTypeData: [],
      dynastyTypeDataJapan: [],//日本年代
      dynastyTypeDataChina: [],
      filterData: [],
      versionTypeFilterData: [],
      categoryFilterData: [],
      vcopierFilterData: [],
      countryTypeFilterData: [],
      dynastyTypeFilterData: [],
      bookSearchData: [],
      totalNum: 0,
      pageNum: 1,
      pageSize: 10,
      totalPage: 1,
      fit: 'fill',
      dialogVisible: true,
      grid: true,
      userlogin: false,//是否登录  登录和非登录状态用不同的列表
    }
  },
  computed: {
    noMore () {
      // if (this.isSearching) {
      //   return this.newParam.total < this.newParam.pageSize
      // } else {
      //   return this.empsearch.total <= this.empsearch.pageSize * this.empsearch.pageNum
      //   // return false;
      // }
      return this.totalNum <= this.pageSize * this.pageNum
    },
    newdisabled () {
      return this.newloading || this.noMore
    },
  },
  created: function () {
    this.inputKey = this.$route.query.keyword
    this.token = localStorage.getItem("token")
    // let parentId = this.parentId
    // let nodeType = this.nodeType
    //传统分类 左侧树形结构
    // this.getBookTree()
    // this.queryIsFavor()
    this.getCategoryTree()
    //条件选择 版本
    getDictTypeTree({
      dictType: "bus_version_type"
    }).then(res => {
      // let versionTypeAll = {}
      // versionTypeAll.label = "全部"
      // versionTypeAll.value = "-1"
      this.versionTypeData = res.data.slice(0, res.data.length - 1)
      this.versionTypeData1 = res.data.slice(-1)
      // this.versionTypeData.unshift(versionTypeAll)
      // this.versionTypeData1.unshift(versionTypeAll)
      this.versionTypeData.forEach((item, i) => {
        if (item.value === '-1') {
          item.classClick = true
        } else {
          item.classClick = false
        }
      })
      // console.log(this.versionTypeData, 'this.versionTypeData')
      this.versionTypeData1.forEach((item, i) => {
        if (item.value === '-1') {
          item.classClick = true
        } else {
          item.classClick = false
        }
        // if (item.children.length > 0) {
        //   item.children.forEach(() => {
        //     item.classClick = false
        //   })
        // }
      })
    })
    //条件选择 刊抄人
    getDictTypeTree({
      dictType: "bus_copier"
    }).then(res => {
      // let copierAll = {}
      // copierAll.label = "全部"
      // copierAll.value = "-1"
      this.vcopierData = res.data
      // this.vcopierData.unshift(copierAll)
      this.vcopierData.forEach((item, i) => {
        // if (item.value === '-1') {
        //   item.classClick = true
        // } else {
        item.classClick = false
        // }
      })

    })
    //条件选择 国别
    getDictType({
      dictType: "bus_country_type"
    }).then(res => {
      // let countryTypeAll = {}
      // countryTypeAll.dictLabel = "全部"
      // countryTypeAll.dictValue = "-1"


      this.countryTypeData = res.data
      // this.countryTypeData.unshift(countryTypeAll)
      this.countryTypeData.forEach((item, i) => {
        // if (item.dictValue === '-1') {
        //   item.classClick = true
        // } else {
        item.classClick = false
        // }
      })
    })

    //条件选择 刊钞年代
    getDictType({
      dictType: "bus_dynasty_type"
    }).then(res => {

      this.dynastyTypeDataChina = res.data

    })
    // 日本年代

    getDynastyJapan().then(res => {
      if (res.code == 200) {
        // console.log(res, 'getDynastyJapan')
        this.dynastyTypeDataJapan = res.data
        this.getDynastyTypeData([-1])
      }


    })
    let islogin = localStorage.token ? true : false
    // console.log(islogin, 'islogin')
    this.essearch(islogin)
  },
  methods: {
    getShareHref (bookName, id, page) {
      let pathtext = '【' + bookName + '】' + window.location.protocol + "//" + window.location.host + "/#/detail?id=" + id + "&page=" + page
      this.copyeverydayword(pathtext)
    },
    copyeverydayword (text) {
      if (window.isSecureContext && navigator.clipboard) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            // this.$message.success("复制成功")
            this.sharetip = text + "<br/>已成功複製到剪切板"
            //setTimeout(() => {
            //  this.sharetip = "獲取詳情分享鏈接"
            //}, 2000)
          })
          .catch((err) => {
            // 复制失败
            // this.$message.error("复制失败")
            this.sharetip = "複製失敗"
            //setTimeout(() => {
            //  this.sharetip = "獲取詳情分享鏈接"
            //}, 2000)
          })

      } else {
        this.unsecuredCopyToClipboard(text)
      }

    },
    unsecuredCopyToClipboard (text) {
      const textArea = document.createElement("textarea")
      textArea.value = text
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      try {
        document.execCommand('copy')
        this.sharetip = text + "<br/>已成功複製到剪切板"
      } catch (err) {
        // console.error('Unable to copy to clipboard', err)
        this.sharetip = "複製失敗"
      }
      document.body.removeChild(textArea)
    },

    newload () {
      this.newloading = true
      setTimeout(() => {
        // if (this.isSearching) {
        this.pageNum += 1
        if (this.userlogin) {
          this.essearch(true)
        } else {
          this.essearch(false)
        }

        this.newloading = false
        // } 
        // else {
        //   this.empSearchChange()
        //   this.newloading = false
        // }
      }, 2000)
    },
    handleClose (index, tag) {
      this.filterData.splice(index, 1)
      if (tag.searchType == 'category' || tag.searchType == 'category1') {
        let findex = this.categoryFilterData.findIndex((id) => id == tag.dictValue)
        this.categoryFilterData.splice(findex, 1)
        //删除父类下的所有子类
        if (tag.searchType == 'category') {
          let cin = this.categoryData.findIndex((citem) => tag.dictValue == citem.id)
          cin > -1 && this.categoryData[cin].children.forEach((child) => {
            let fin = this.filterData.findIndex((ccitem) => child.id == ccitem.dictValue)
            if (fin > -1) {
              this.filterData.splice(fin, 1)

              let findex = this.categoryFilterData.findIndex((id) => id == child.id)
              this.categoryFilterData.splice(findex, 1)
            }
          })
        }
        //删除子类，如果没其它子类，查询条件保留父类
        if (tag.searchType == 'category1') {
          let cin = this.categoryData.findIndex((citem) => tag.parentId == citem.id)

          let isall = this.categoryData[cin].children.every((ccitem) => {
            let temindex = this.filterData.findIndex((ccc) => ccitem.id == ccc.dictValue)
            return temindex == -1
          })
          if (isall) {
            let ti = this.filterData.findIndex((fitem) => fitem.dictValue == tag.parentId)
            this.filterData[ti].iscondition = true
          }

        }
      }
      if (tag.searchType == 'versionType' || tag.searchType == 'versionType1' || tag.searchType == 'versionType11') {
        let findex = this.versionTypeFilterData.findIndex((id) => id == tag.dictValue)
        this.versionTypeFilterData.splice(findex, 1)

        //删除父类下的所有子类
        if (tag.searchType == 'versionType') {
          let cin = this.versionTypeData.findIndex((citem) => tag.dictValue == citem.id)
          cin > -1 && this.versionTypeData[cin].children && this.versionTypeData[cin].children.forEach((child) => {
            let fin = this.filterData.findIndex((ccitem) => child.id == ccitem.dictValue)
            if (fin > -1) {
              this.filterData.splice(fin, 1)

              let findex = this.versionTypeFilterData.findIndex((id) => id == child.id)
              this.versionTypeFilterData.splice(findex, 1)
            }
          })
        }
        //删除子类，如果没其它子类，查询条件保留父类
        if (tag.searchType == 'versionType11') {
          let cin = this.versionTypeData.findIndex((citem) => tag.parentId == citem.id)

          let isall = this.versionTypeData[cin].children.every((ccitem) => {
            let temindex = this.filterData.findIndex((ccc) => ccitem.id == ccc.dictValue)
            return temindex == -1
          })
          if (isall) {
            let ti = this.filterData.findIndex((fitem) => fitem.dictValue == tag.parentId)
            this.filterData[ti].iscondition = true
          }

        }
      }
      if (tag.searchType == 'vcopier' || tag.searchType == 'vcopier1') {
        let findex = this.vcopierFilterData.findIndex((id) => id == tag.dictValue)
        this.vcopierFilterData.splice(findex, 1)

        //删除父类下的所有子类
        if (tag.searchType == 'vcopier') {
          let cin = this.vcopierData.findIndex((citem) => tag.dictValue == citem.id)
          cin > -1 && this.vcopierData[cin].children && this.vcopierData[cin].children.forEach((child) => {
            let fin = this.filterData.findIndex((ccitem) => child.id == ccitem.dictValue)
            if (fin > -1) {
              this.filterData.splice(fin, 1)

              let findex = this.vcopierFilterData.findIndex((id) => id == child.id)
              this.vcopierFilterData.splice(findex, 1)
            }
          })
        }

        //删除子类，如果没其它子类，查询条件保留父类
        if (tag.searchType == 'vcopier1') {
          let cin = this.vcopierData.findIndex((citem) => tag.parentId == citem.id)

          let isall = this.vcopierData[cin].children.every((ccitem) => {
            let temindex = this.filterData.findIndex((ccc) => ccitem.id == ccc.dictValue)
            return temindex == -1
          })
          if (isall) {
            let ti = this.filterData.findIndex((fitem) => fitem.dictValue == tag.parentId)
            this.filterData[ti].iscondition = true
          }

        }
      }
      if (tag.searchType == 'countryType') {
        let findex = this.countryTypeFilterData.findIndex((id) => id == tag.dictValue)
        this.countryTypeFilterData.splice(findex, 1)
        this.getDynastyTypeData(this.countryTypeFilterData)
      }
      if (tag.searchType == 'dynastyType') {
        let findex = this.dynastyTypeFilterData.findIndex((id) => id == tag.dictValue)
        this.dynastyTypeFilterData.splice(findex, 1)
      }
      this.bookSearchData = []
      this.pageNum = 1
      this.essearch(true)
    },
    // getBookTree (type = "All", parentId = 0, nodeType = 'category') {

    //   booksTree({
    //     parentId: parentId,
    //     nodeType: nodeType
    //   }).then(res => {
    //     // this.treeData = res.data
    //     if (type == "All") {
    //       this.categoryData = res.data
    //       let categoryAll = {}
    //       categoryAll.name = "全部"
    //       categoryAll.id = "-1"
    //       this.categoryData.unshift(categoryAll)
    //       this.categoryData.forEach((item, i) => {
    //         if (item.id == '-1') {
    //           item.classClick = true
    //         } else {
    //           item.classClick = false
    //         }
    //       })

    //     } else {
    //       this.categoryLeiData = res.data
    //       let categoryLeiAll = {}
    //       categoryLeiAll.name = "全部"
    //       categoryLeiAll.id = "-1"
    //       this.categoryLeiData.unshift(categoryLeiAll)
    //       this.categoryLeiData.forEach((item, i) => {
    //         if (item.id == '-1') {
    //           item.classClick = true
    //         } else {
    //           item.classClick = false
    //         }
    //       })


    //     }

    //   })

    // },

    //-1全部 type=1中国 type=2日本 type=3朝鲜
    getDynastyTypeData (typearr) {
      // console.log(typearr, 'typearr')
      this.dynastyTypeData = []
      if (typearr.length > 0) {
        typearr.forEach((type) => {
          if (type == -1) {
            this.dynastyTypeData = [...this.dynastyTypeDataChina]
          } else if (type == 0) {
            this.dynastyTypeData = [...this.dynastyTypeData, ...this.dynastyTypeDataChina]
          } else if (type == 1) {
            this.dynastyTypeData = [...this.dynastyTypeData, ...this.dynastyTypeDataJapan]
          } else {
            this.dynastyTypeData = [...this.dynastyTypeData]
          }

        })

      } else {
        this.dynastyTypeData = [...this.dynastyTypeDataChina, ...this.dynastyTypeDataJapan]
      }



      if (this.dynastyTypeData.length > 0) {
        let dynastyTypeAll = {}
        // dynastyTypeAll.dictLabel = "全部"
        // dynastyTypeAll.dictValue = "-1"
        // this.dynastyTypeData.unshift(dynastyTypeAll)
        this.dynastyTypeData.forEach((item, i) => {
          // if (item.dictValue === '-1') {
          //   item.classClick = true
          // } else {
          item.classClick = false
          // }
        })
      }

    },
    // queryIsFavor () {
    //   isFavor(this.$route.query.id).then((res) => {
    //     this.isFavor = res.isFavor
    //   })
    // },
    clickMenu (bookId, favorId) {
      // if (type === 1) {
      // isFavor(bookId).then((res) => {
      if (favorId) {
        deleteFavor(favorId).then((res) => {
          // this.queryIsFavor()
          if (res.code === 200) {
            this.bookSearchData = []
            this.pageNum = 1
            this.essearch(true)
            this.$message.success('取消收藏')
          }
          // else {
          //   this.$message.error(res.msg)
          // }
        })
      } else {
        favorAdd({
          bookId: bookId
        }).then((res) => {
          // this.queryIsFavor()
          if (res.code === 200) {
            this.bookSearchData = []
            this.pageNum = 1
            this.essearch(true)
            this.$message.success('收藏成功')
          }
          // else {
          //   this.$message.error(res.msg)
          // }
        })
      }

      // })
      // }
      // if (type === 2) {
      //   this.dialogVisible = true
      // }
      // if (type === 3) {
      //   this.$router.push({
      //     path: '/view',
      //     query: { ...this.$route.query, catId: this.catalogueList[0].id }
      //   })
      // }
    },

    getCategoryTree () {
      categoryTree().then(res => {
        // this.treeData = res.data
        this.categoryData = res.data
        // let categoryAll = {}
        // categoryAll.name = "全部"
        // categoryAll.id = "-1"
        // this.categoryData.unshift(categoryAll)
        // this.categoryLeiData = []
        this.categoryData.forEach((item, i) => {
          // if (item.id === '-1') {
          //   item.classClick = true
          // } else {
          item.classClick = false
          // }
          // this.categoryLeiData = item.children ? [...this.categoryLeiData, ...item.children] : this.categoryLeiData
        })
        // console.log(this.categoryLeiData, 'this.categoryLeiData')
        // this.categoryLeiData.forEach((item1, i) => {
        //   item1.classClick = false
        // })

      })

    },

    currentChange (index) {
      this.pageNum = index
      this.essearch(true)
    },
    // 点击范围筛选
    // clickFw (item) {
    //   this.fw = item
    //   const findIndex = this.list.findIndex((row) => row.key === 'fw')
    //   if (findIndex !== -1) {
    //     this.list[findIndex].value = item
    //   } else {
    //     this.list.push({
    //       key: 'fw',
    //       value: item
    //     })
    //   }
    //   this.essearch()
    // },
    // // 选择版本
    // clickVersionType (item, index) {
    //   this.versionType = item.dictValue
    //   const findIndex = this.list.findIndex((row) => row.key === 'versionType')
    //   if (findIndex !== -1) {
    //     this.list[findIndex].value = item.dictLabel
    //   } else {
    //     this.list.push({
    //       key: 'versionType',
    //       value: item.dictLabel
    //     })
    //   }
    //   this.essearch()
    // },
    // //选择四部
    // clickCategory (item, index) {
    //   this.category = item.id
    //   const findIndex = this.list.findIndex((row) => row.key === 'category')
    //   if (findIndex !== -1) {
    //     this.list[findIndex].value = item.name
    //   } else {
    //     this.list.push({
    //       key: 'category',
    //       value: item.name
    //     })
    //   }
    //   this.essearch()
    // },
    // 选择杆抄人
    // clickVcopierData (item, index) {
    //   this.vcopier = item.dictValue
    //   const findIndex = this.list.findIndex((row) => row.key === 'vcopier')
    //   if (findIndex !== -1) {
    //     this.list[findIndex].value = item.dictLabel
    //   } else {
    //     this.list.push({
    //       key: 'vcopier',
    //       value: item.dictLabel
    //     })
    //   }
    //   this.essearch()
    // },
    // clickCountryTypeData (item, index) {
    //   this.countryType = item.dictValue
    //   const findIndex = this.list.findIndex((row) => row.key === 'countryType')
    //   if (findIndex !== -1) {
    //     this.list[findIndex].value = item.dictLabel
    //   } else {
    //     this.list.push({
    //       key: 'countryType',
    //       value: item.dictLabel
    //     })
    //   }
    //   this.essearch()
    // },
    // clickDynastyTypeData (item, index) {
    //   this.dynastyType = item.dictValue
    //   const findIndex = this.list.findIndex((row) => row.key === 'dynastyType')
    //   if (findIndex !== -1) {
    //     this.list[findIndex].value = item.dictLabel
    //   } else {
    //     this.list.push({
    //       key: 'dynastyType',
    //       value: item.dictLabel
    //     })
    //   }
    //   this.essearch()
    // },
    renderContent (h, {
      node,
      data,
      store
    }) {
      return (<span class="custom-tree-node">
        <span>{data.name}</span> </span>
      )
    },
    loadNode (node, resolve) {
      // console.log(node)
      if (node.level === 0) {
        return resolve([{
          name: '正在加载数据'
        }])
      }
      let parentId = node.data.id
      let nodeType = node.data.nodeType
      let token = this.token
      booksTree({
        parentId: parentId,
        nodeType: nodeType,
        token: token
      }).then(res => {
        resolve(res.data)
      })
    },
    // 节点单击事件
    handleNodeClick (data) {
      const findIndex = this.categoryData.findIndex((item) => item.id === data.id)
      if (findIndex !== -1) {
        this.category = data.id
        if (this.categoryFilterData.indexOf(data.id) === -1) {
          this.categoryFilterData.push(data.id)
          this.categoryData[findIndex].classClick = true
          this.filterData.push({
            searchType: 'category',
            dictValue: this.categoryData[findIndex].id,
            dictLabel: this.categoryData[findIndex].name
          })
        }
        this.essearch()
      }

    },
    filterSearch (searchType, dictValue, dictLabel, item, index, parentid = '') {

      // console.log(searchType, dictValue, dictLabel, item, index)
      this.bookSearchData = []
      this.pageNum = 1
      if (searchType == "fw") {
        if (dictValue === '全部') {
          this.fwList.map((item) => {
            if (item.classClick) {
              const fIndex = this.filterData.findIndex((row) => row.dictValue === item.name)
              this.filterData.splice(fIndex, 1)
              item.classClick = false
            }
          })
          this.fwFilterData = []
          this.fwList[0].classClick = true
        } else {
          this.fwList[0].classClick = false
          this.fwList[index].classClick = !this.fwList[index].classClick
          this.fwList = this.fwList.concat([])
          const findIndex = this.fwFilterData.findIndex((item) => item === dictValue)
          if (findIndex < 0) {
            this.fwFilterData.push(dictValue)
            this.filterData.push({
              searchType: searchType,
              dictValue: dictValue,
              dictLabel: dictLabel
            })
          } else {
            this.fwFilterData.splice(findIndex, 1)
            const fIndex = this.filterData.findIndex((item) => item.dictValue === dictValue)
            this.filterData.splice(fIndex, 1)
          }
        }

      }
      if (searchType == "versionType") {

        // if (dictValue === '-1') {
        //   this.versionTypeData.map((item) => {
        //     if (item.classClick) {
        //       const fIndex = this.filterData.findIndex((row) => row.dictValue === item.dictValue)
        //       this.filterData.splice(fIndex, 1)
        //       item.classClick = false
        //     }
        //   })
        //   this.versionTypeFilterData = []
        //   this.versionTypeData[0].classClick = true
        // } else {
        //   this.versionTypeData[0].classClick = false
        //   this.versionTypeData[index].classClick = !this.versionTypeData[index].classClick
        //   this.versionTypeData = this.versionTypeData.concat([])

        const findIndex = this.versionTypeFilterData.findIndex((item) => item === dictValue)
        this.versionTypeData11 = this.versionTypeData[index].children ? this.versionTypeData[index].children : []
        this.versionTypeData11.forEach((item) => {
          item.parentId = dictValue
        })
        if (findIndex < 0) {
          this.versionTypeFilterData.push(dictValue)
          this.filterData.push({
            searchType: searchType,
            dictValue: dictValue,
            dictLabel: dictLabel,
            iscondition: true
          })
          // this.versionTypeData11 = this.versionTypeData[index].children ? this.versionTypeData[index].children : []
        }
        // else {
        //   this.versionTypeFilterData.splice(findIndex, 1)
        //   const fIndex = this.filterData.findIndex((item) => item.dictValue === dictValue)
        //   this.filterData.splice(fIndex, 1)

        // if (this.versionTypeData[index].children && this.versionTypeData[index].children.length > 0) {

        //   this.versionTypeData[index].children.forEach((item1) => {
        //     let tIndex = this.versionTypeFilterData.findIndex((row) => row === item1.id)
        //     if (tIndex > -1) {
        //       this.versionTypeFilterData.splice(tIndex, 1)
        //       const ffIndex = this.filterData.findIndex((row) => row.dictValue === item1.id)
        //       this.filterData.splice(ffIndex, 1)
        //     }
        //   })
        // }
        // }


      }
      if (searchType == "versionType1") {

        // if (dictValue === '-1') {
        //   this.versionTypeData1.map((item) => {
        //     if (item.classClick) {
        //       const fIndex = this.filterData.findIndex((row) => row.dictValue === item.dictValue)
        //       this.filterData.splice(fIndex, 1)
        //       item.classClick = false
        //     }

        //   })
        //   this.versionTypeFilterData = []
        //   this.versionTypeData1[0].classClick = true
        // } else {

        //   this.versionTypeData1[index].classClick = !this.versionTypeData1[index].classClick
        //   this.versionTypeData1 = this.versionTypeData1.concat([])

        const findIndex = this.versionTypeFilterData.findIndex((item) => item === dictValue)
        // console.log(findIndex, 'findIndex')
        if (findIndex < 0) {
          this.versionTypeFilterData.push(dictValue)
          this.filterData.push({
            searchType: searchType,
            dictValue: dictValue,
            dictLabel: dictLabel,
            iscondition: true
          })
        }
        // else {
        //   this.versionTypeFilterData.splice(findIndex, 1)
        //   const fIndex = this.filterData.findIndex((item) => item.dictValue === dictValue)
        //   this.filterData.splice(fIndex, 1)
        // }
        // }

      }
      if (searchType == "versionType11") {



        const findIndex = this.versionTypeFilterData.findIndex((item) => item === dictValue)
        // console.log(findIndex, 'findIndex')
        if (findIndex < 0) {
          this.versionTypeFilterData.push(dictValue)
          this.filterData.push({
            searchType: searchType,
            dictValue: dictValue,
            dictLabel: dictLabel,
            isChild: true,
            parentId: item.parentId,
            iscondition: true
          })
          //选择子类 去掉父类
          this.filterData.forEach((a) => {
            if (a.dictValue == item.parentId && a.searchType == "versionType") {
              a.iscondition = false
            }
          })
        }
        // else {
        //   this.versionTypeFilterData.splice(findIndex, 1)
        //   const fIndex = this.filterData.findIndex((item) => item.dictValue === dictValue)
        //   this.filterData.splice(fIndex, 1)
        // }


      }
      if (searchType == "category") {
        //获取类
        this.categoryLeiData = []
        if (this.categoryData[index].children) this.categoryLeiData = [...this.categoryData[index].children]
        const findIndex = this.categoryFilterData.findIndex((row) => row === item.id)

        if (findIndex < 0) {
          this.categoryFilterData.push(item.id)
          this.filterData.push({
            searchType: searchType,
            dictValue: item.id,
            dictLabel: item.name,
            iscondition: true
          })

          // let tempindex = this.categoryData.findIndex((row) => row.id === item.id)
          // console.log(tempindex, 'tempindex')



        }
        // else {
        //   this.categoryFilterData.splice(findIndex, 1)
        //   const fIndex = this.filterData.findIndex((row) => row.dictValue === item.id)
        //   this.filterData.splice(fIndex, 1)

        // if (this.categoryData[index].children && this.categoryData[index].children.length > 0) {

        //   this.categoryData[index].children.forEach((item1) => {
        //     let tIndex = this.categoryFilterData.findIndex((row) => row === item1.id)
        //     if (tIndex > -1) {
        //       this.categoryFilterData.splice(tIndex, 1)
        //       const ffIndex = this.filterData.findIndex((row) => row.dictValue === item1.id)
        //       this.filterData.splice(ffIndex, 1)
        //     }
        //   })
        // }

        // }



      }
      if (searchType == "category1") {

        const findIndex = this.categoryFilterData.findIndex((row) => row == dictValue)

        if (findIndex < 0) {
          this.categoryFilterData.push(item.id)
          this.filterData.push({
            searchType: searchType,
            dictValue: item.id,
            dictLabel: item.name,
            isChild: true,
            parentId: item.parentId,
            iscondition: true
          })

          //选择子类 去掉父类
          this.filterData.forEach((a) => {
            if (a.dictValue == item.parentId && a.searchType == "category") {
              a.iscondition = false
            }
          })
        }
        // else {
        //   this.categoryFilterData.splice(findIndex, 1)
        //   const fIndex = this.filterData.findIndex((row) => row.dictValue === item.id)
        //   this.filterData.splice(fIndex, 1)
        // }


      }

      if (searchType == "vcopier" || searchType == "vcopier1") {

        const findIndex = this.vcopierFilterData.findIndex((row) => row === dictValue)
        if (findIndex < 0) {
          this.vcopierFilterData.push(dictValue)
          if (searchType == "vcopier1") {
            this.filterData.push({
              searchType: searchType,
              dictValue: dictValue,
              dictLabel: dictLabel,
              isChild: true,
              parentId: item.parentId,
              iscondition: true
            })

            //选择子类 去掉父类
            this.filterData.forEach((a) => {
              if (a.dictValue == item.parentId && a.searchType == "vcopier") {
                a.iscondition = false
              }
            })

          } else {
            this.filterData.push({
              searchType: searchType,
              dictValue: dictValue,
              dictLabel: dictLabel,
              iscondition: true
            })
          }

        }
        // else {
        //   this.vcopierFilterData.splice(findIndex, 1)
        //   const fIndex = this.filterData.findIndex((item) => item.dictValue === dictValue)
        //   this.filterData.splice(fIndex, 1)

        // if (this.vcopierData[index].children && this.vcopierData[index].children.length > 0) {

        //   this.vcopierData[index].children.forEach((item1) => {
        //     let tIndex = this.vcopierFilterData.findIndex((row) => row === item1.id)
        //     if (tIndex > -1) {
        //       this.vcopierFilterData.splice(tIndex, 1)
        //       const ffIndex = this.filterData.findIndex((row) => row.dictValue === item1.id)
        //       this.filterData.splice(ffIndex, 1)
        //     }
        //   })
        // }
        // }


        if (searchType == "vcopier") {
          this.vcopierData1 = this.vcopierData[index].children ? this.vcopierData[index].children : []
          this.vcopierData1.forEach((v) => {
            v.parentId = dictValue
          })
        }
      }


      if (searchType == "countryType") {
        // console.log(dictValue, 'dictValue')

        // if (dictValue === '-1') {

        //   this.countryTypeData.map((item) => {
        //     if (item.classClick) {
        //       const fIndex = this.filterData.findIndex((row) => row.dictValue === item.dictValue)
        //       this.filterData.splice(fIndex, 1)
        //       item.classClick = false
        //     }
        //   })
        //   this.countryTypeFilterData = []
        //   this.countryTypeData[0].classClick = true
        // } else {

        //   this.countryTypeData[0].classClick = false
        //   item.classClick = !item.classClick
        //   this.$set(this.countryTypeData, index, item)
        const findIndex = this.countryTypeFilterData.findIndex((item) => item === dictValue)
        if (findIndex < 0) {
          this.countryTypeFilterData.push(dictValue)
          this.filterData.push({
            searchType: searchType,
            dictValue: dictValue,
            dictLabel: dictLabel,
            iscondition: true
          })
        }
        // else {
        //   this.countryTypeFilterData.splice(findIndex, 1)
        //   const fIndex = this.filterData.findIndex((item) => item.dictValue === dictValue)
        //   this.filterData.splice(fIndex, 1)
        //   if (index == 1) {
        //     console.log(this.dynastyTypeDataJapan, 'this.dynastyTypeDataJapan')
        //     this.dynastyTypeDataJapan.forEach((item1) => {
        //       let tIndex = this.dynastyTypeFilterData.findIndex((row) => row === item1.dictValue)
        //       if (tIndex > -1) {
        //         this.dynastyTypeFilterData.splice(tIndex, 1)
        //         const ffIndex = this.filterData.findIndex((row) => row.dictValue === item1.dictValue)
        //         this.filterData.splice(ffIndex, 1)
        //       }
        //     })
        //   }
        //   if (index == 0) {
        //     this.dynastyTypeDataChina.forEach((item1) => {
        //       let tIndex = this.dynastyTypeFilterData.findIndex((row) => row === item1.dictValue)
        //       if (tIndex > -1) {
        //         this.dynastyTypeFilterData.splice(tIndex, 1)
        //         const ffIndex = this.filterData.findIndex((row) => row.dictValue === item1.dictValue)
        //         this.filterData.splice(ffIndex, 1)
        //       }
        //     })
        //   }
        // }
        // }
        this.getDynastyTypeData(this.countryTypeFilterData)
      }

      if (searchType == "dynastyType") {
        // if (dictValue === '-1') {
        //   this.dynastyTypeData.map((item) => {
        //     if (item.classClick) {
        //       const fIndex = this.filterData.findIndex((row) => row.dictValue === item.dictValue)
        //       this.filterData.splice(fIndex, 1)
        //       item.classClick = false
        //     }
        //   })
        //   this.dynastyTypeFilterData = []
        //   this.dynastyTypeData[0].classClick = true
        // } else {
        //   this.dynastyTypeData[0].classClick = false
        //   item.classClick = !item.classClick
        //   this.$set(this.dynastyTypeData, index, item)
        const findIndex = this.dynastyTypeFilterData.findIndex((item) => item === dictValue)
        if (findIndex < 0) {
          this.dynastyTypeFilterData.push(dictValue)
          this.filterData.push({
            searchType: searchType,
            dictValue: dictValue,
            dictLabel: dictLabel,
            iscondition: true
          })
        } else {
          this.dynastyTypeFilterData.splice(findIndex, 1)
          const fIndex = this.filterData.findIndex((item) => item.dictValue === dictValue)
          this.filterData.splice(fIndex, 1)
        }
        // }
      }
      this.essearch(true)
    },
    filterClear () {
      this.filterData = []
      this.versionTypeFilterData = []
      this.categoryFilterData = []
      this.vcopierFilterData = []
      this.countryTypeFilterData = []
      this.dynastyTypeFilterData = []
      this.bookSearchData = []
      this.pageNum = 1
      this.essearch(true)

      // this.versionTypeData.map((item) => {
      //   item.classClick = false
      // })
      // this.countryTypeData.map((item) => {
      //   item.classClick = false
      // })
      // this.categoryData.map((item) => {
      //   item.classClick = false
      // })
      // this.vcopierData.map((item) => {
      //   item.classClick = false
      // })
      // this.dynastyTypeData.map((item) => {
      //   item.classClick = false
      // })
    },
    qhGrid () {
      this.grid = !this.grid
    },
    filterMover1 (item, index, flag) {
      debugger
      this[item.key] = ''
      this.list.splice(index, 1)
      if (!flag) {
        this.essearch()
      }
    },
    filterMover (searchType, dictValue, dictLabel, index) {
      if (searchType == "fw" && this.fwFilterData.indexOf(dictValue) >= 0) {
        this.fwFilterData.splice(this.fwFilterData.indexOf(dictValue), 1)
        this.fwList.filter((item, index) => {
          if (item.name == dictValue) {
            item.classClick = !item.classClick
          }
        })
        if (this.fwFilterData.length === 0) {
          this.fwList[0].classClick = true
        }
      }
      if (searchType == "versionType" && this.versionTypeFilterData.indexOf(dictValue) >= 0) {
        this.versionTypeFilterData.splice(this.versionTypeFilterData.indexOf(dictValue), 1)
        this.versionTypeData.filter((item, index) => {
          if (item.dictValue == dictValue) {
            item.classClick = !item.classClick
          }
        })
        if (this.versionTypeFilterData.length === 0) {
          this.versionTypeData[0].classClick = true
        }
      }
      if (searchType == "category" && this.categoryFilterData.indexOf(dictValue) >= 0) {
        this.categoryFilterData.splice(this.categoryFilterData.indexOf(dictValue), 1)
        this.categoryData.filter((item, index) => {
          if (item.id == dictValue) {
            item.classClick = !item.classClick
          }
        })
      }

      if (searchType == "vcopier" && this.vcopierFilterData.indexOf(dictValue) >= 0) {
        this.vcopierFilterData.splice(this.vcopierFilterData.indexOf(dictValue), 1)
        this.vcopierData.filter((item, index) => {
          if (item.dictValue == dictValue) {
            item.classClick = !item.classClick
          }
        })
        if (this.vcopierFilterData.length === 0) {
          this.vcopierData[0].classClick = true
        }
      }

      if (searchType == "countryType" && this.countryTypeFilterData.indexOf(dictValue) >= 0) {
        this.countryTypeFilterData.splice(this.countryTypeFilterData.indexOf(dictValue), 1)
        this.countryTypeData.filter((item, index) => {
          if (item.dictValue == dictValue) {
            item.classClick = !item.classClick
          }
        })
        if (this.countryTypeFilterData.length === 0) {
          this.countryTypeData[0].classClick = true
        }
        //console.log(this.countryTypeData);
      }
      // console.log(this.dynastyTypeFilterData)
      if (searchType == "dynastyType" && this.dynastyTypeFilterData.indexOf(dictValue) >= 0) {
        this.dynastyTypeFilterData.splice(this.dynastyTypeFilterData.indexOf(dictValue), 1)
        this.dynastyTypeData.filter((item, index) => {
          if (item.dictValue == dictValue) {
            item.classClick = !item.classClick
          }
        })
        if (this.dynastyTypeFilterData.length === 0) {
          this.dynastyTypeData[0].classClick = true
        }
      }
      this.filterData.splice(index, 1)
      this.essearch()
    },
    keySearch () {
      this.pageNum = 1
      this.bookSearchData = []
      this.essearch(true)
    },
    essearch (userlogin = false) {
      this.userlogin = userlogin
      let searchjson = {}
      // this.bookSearchData = []
      // this.pageNum = 1
      searchjson.pageSize = this.pageSize
      searchjson.pageNum = this.pageNum
      searchjson.bookName = this.inputKey
      searchjson.summary = ""
      searchjson.charger = ""
      searchjson.bookText = ""


      // if (this.fwFilterData.length > 0) {
      //   if (this.fwFilterData.indexOf('书名') != -1) {
      //     searchjson.bookName = this.inputKey
      //   }
      //   if (this.fwFilterData.indexOf('介绍') != -1) {
      //     searchjson.summary = this.inputKey
      //   }
      //   if (this.fwFilterData.indexOf('作者') != -1) {
      //     searchjson.charger = this.inputKey
      //   }
      //   if (this.fwFilterData.indexOf('全文') != -1) {
      //     searchjson.bookText = this.inputKey
      //   }
      // }
      if (this.versionTypeFilterData.length > 0) {
        let tmpv = []
        this.versionTypeFilterData.forEach((item) => {
          let temi = this.filterData.findIndex((citem) => (citem.searchType == 'versionType' || citem.searchType == 'versionType1' || citem.searchType == 'versionType11') && citem.dictValue == item)
          if (this.filterData[temi].iscondition) {
            tmpv.push(item)
          }
        })
        searchjson.versionType = tmpv.join(',')
        // searchjson.versionType = this.versionTypeFilterData.join(',')

      }
      if (this.categoryFilterData.length > 0) {
        let tmpv = []
        this.categoryFilterData.forEach((item) => {
          let temi = this.filterData.findIndex((citem) => (citem.searchType == 'category' || citem.searchType == 'category1') && citem.dictValue == item)
          if (this.filterData[temi].iscondition) {
            tmpv.push(item)
          }
        })
        searchjson.categoryIds = tmpv.join(',')
        // searchjson.categoryIds = this.categoryFilterData.join(',')
      }
      if (this.countryTypeFilterData.length > 0) {
        searchjson.country = this.countryTypeFilterData.join(',')
      }
      if (this.vcopierFilterData.length > 0) {
        let tmpv = []
        this.vcopierFilterData.forEach((item) => {
          let temi = this.filterData.findIndex((citem) => (citem.searchType == 'vcopier' || citem.searchType == 'vcopier1') && citem.dictValue == item)
          if (this.filterData[temi].iscondition) {
            tmpv.push(item)
          }
        })
        searchjson.copier = tmpv.join(',')
        // searchjson.copier = this.vcopierFilterData.join(',')
      }
      if (this.dynastyTypeFilterData.length > 0) {
        searchjson.copyDynasty = this.dynastyTypeFilterData.join(',')
      }
      searchjson.bookId = ""
      // searchjson.token = this.token
      // essearch(searchjson).then(res => {
      if (userlogin) {

        bookListUser(searchjson).then(res => {
          this.totalNum = res.total
          this.bookSearchData = [...this.bookSearchData, ...res.rows]
        })
      } else {
        // console.log(searchjson, 'searchjson')
        bookList(searchjson).then(res => {
          this.totalNum = res.total
          this.bookSearchData = [...this.bookSearchData, ...res.rows]
        })

      }

      // this.totalPage = res.totalPages
      // res.data.map((item) => {
      //   if (item.pageText) {
      //     item.pageText = item.pageText.replaceAll('一', '').replaceAll('\\n', '')
      //     item.pageText = item.pageText.replaceAll(this.inputKey,
      //       `<span style="color:red">${this.inputKey}</span>`)
      //   }
      //   if (this.fwFilterData.indexOf('书名') !== -1 || this.fwFilterData.length === 0) {
      //     if (item.bookName) {
      //       item.bookNameHtml = item.bookName.replaceAll(this.inputKey,
      //         `<span style="color:red">${this.inputKey}</span>`)
      //     }
      //   }
      //   if (this.fwFilterData.indexOf('作者') !== -1 || this.fwFilterData.length === 0) {
      //     if (item.charger) {
      //       item.chargerHtml = item.charger.replaceAll(this.inputKey,
      //         `<span style="color:red">${this.inputKey}</span>`)
      //     }
      //   }
      //   if (item.bookVersion) {
      //     item.bookVersion = item.bookVersion.replaceAll(this.inputKey,
      //       `<span style="color:red">${this.inputKey}</span>`)
      //   }
      // })
      //console.log(res.data);
      // this.bookSearchData = res.rows || []
    },
    gotodeatail (id, page) {
      let url = "/detail?id=" + id + "&page=" + page
      this.$router.push(url)
    },
    gotoview (id) {
      let url = "/view?id=" + id + "&page=" + 1
      //  +"&catId=" +this.catalogueList[0].id
      this.$router.push(url)
    }
  }
}

</script>
<style scoped lang="less">
.sellianjie {
  display: flex;
}
/deep/.el-popover {
  padding: 10px;
}
/deep/.el-input__inner:focus {
  border-color: rgb(170, 29, 31);
}
/deep/.el-icon-search:before {
  color: rgb(170, 29, 31);
}
/deep/.el-input__inner {
  border: 1px solid #bbb;
  color: #000;
}
.cursorpointer {
  cursor: pointer;
}
.cursornwresize {
  cursor: default;
}

html {
  font-size: 37.5px;
}
/deep/.el-tag {
  margin: 5px;
}
/deep/.el-tag.el-tag--danger {
  background-color: #fff;
  border-color: #aa1d1f;
  color: #aa1d1f;
}
/deep/.el-tag.el-tag--danger .el-tag__close {
  color: #aa1d1f;
}
/deep/.el-tag.el-tag--danger {
  margin-right: 20px;
}

.page {
  position: relative;
  height: 87.2vh !important;
  background-color: rgba(245, 245, 245, 1);
  padding-top: 6px;
  overflow: hidden;
}

.bd1 {
  width: 100%;
  height: auto !important;
}

.el-tree {
  height: 0.534rem !important;
  font-size: 16px !important;
  // font-family: PingFangSC-Medium !important;
  color: rgba(38, 38, 38, 1) !important;
  line-height: 0.534rem !important;
  text-align: left !important;
  margin: 0.294rem 0 0 0.214rem !important;
  background: none !important;
}

.item {
  height: 0.654rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 16px;
  // font-family: PingFangTC-Regular;
  white-space: nowrap;
  line-height: 0.654rem;
  justify-content: center;
  text-align: left;
}

.itembutton {
  cursor: pointer;
  border: 1px solid white !important;
  font-size: 15px;
  // font-family: PingFangTC-Regular !important;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 8px;
  padding-right: 8px;
  margin-bottom: 5px;

  .childbutton {
    padding: 0 10px;
  }
}

.itembuttonclick {
  cursor: pointer;
  border-radius: 3px !important;
  border: 1px solid #aa1d1f !important;
  color: #aa1d1f !important;
  // background-color: #ffffff !important;
  font-size: 15px;
  // font-family: PingFangTC-Regular !important;
  height: 28px;
  padding-left: 8px;
  padding-right: 8px;
  margin-bottom: 5px;
  display: flex;
  // margin-bottom: 5px;
  justify-content: center;
  align-items: center;
}
.secondTitle {
  font-size: 14px;
  color: #606266;
}

.itembutton:focus {
  border-radius: 2px !important;
  border: 1px solid #aa1d1f !important;
  color: #aa1d1f !important;
  background-color: #ffffff !important;
}

.itembutton:hover {
  color: #aa1d1f !important;
  background-color: #ffffff !important;
}

.itembutton:active {
  border-radius: 2px !important;
  border: 1px solid #aa1d1f !important;
  color: #aa1d1f !important;
  background-color: #ffffff !important;
}

.itembutton:visited {
  border-radius: 2px !important;
  border: 1px solid #aa1d1f !important;
  color: #aa1d1f !important;
  background-color: #ffffff !important;
}

.txtsearch {
  width: 534px;
  height: 32px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.15);
}

.txtsearch {
  input {
    border-radius: 2px !important;
    height: 32px !important;
    line-height: 32px !important;
    padding: 0 15px !important;
    width: 100%;
    font-size: 16px;
  }
}

.mod3search {
  display: flex;
  align-items: center;
  padding: 0px 20px;
  // height: 47px;
  background-color: #fff;
  /* background: linear-gradient(18deg, #e4e4e2 0%, #f3f3f3 100%); */
}
.searchtype {
  background-color: #fff;
  margin-top: 3px;
  padding: 5px 0 5px 20px;
}

.word20search {
  // width: 0.64rem;
  // height: 0.64rem;
  // display: block;
  // overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  font-weight: 600;
  // font-family: PingFangTC-Medium;
  // white-space: nowrap;
  line-height: 1rem;
  // text-align: right;
  margin-right: 5px 20px 5px 5px;
}

.btnsearch {
  width: 1.6rem;
  height: 32px;
  line-height: 0.74rem;
  background: rgba(170, 29, 31, 1);
  padding: 0 0;
  font-size: 16px;
  // font-family: PingFangTC-Medium;
  color: #ffffff;
  margin-left: 0.3rem;
}

.btnclear {
  color: rgba(38, 38, 38, 1);
  font-size: 16px;
  // font-family: PingFangSC-Medium;
}

.layer6 {
  width: 100%;
  box-sizing: border-box;
  height: auto !important;
  /* margin: 0.5rem 0 0 1rem; */
  // display: flex;
  // justify-content: space-around;

  display: -webkit-box;
  flex: 1;
  flex-grow: 1;
  // overflow: hidden;
}

.box1 {
  height: auto !important;
  /* border: 1px solid #e5e5e5; */
  // background-size: 6.187rem 13.84rem;
  // width: 22%;
  width: 350px;
  padding: 0;
  background-color: #fff;
  margin-left: 20px;
}

.outer1 {
  width: 6.134rem;
  height: auto !important;
}

.main1 {
  z-index: 517;
  position: relative;
  width: 6.134rem;
  height: 1.014rem;
  overflow: hidden;
  /* background: linear-gradient(18deg, #e4e4e2 0%, #f3f3f3 100%); */
}

.word5 {
  z-index: 518;
  position: absolute;
  left: 0.427rem;
  top: 0.24rem;
  width: 1.707rem;
  height: 0.587rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.426rem;
  // font-family: PingFangSC-Medium;
  white-space: nowrap;
  line-height: 0.587rem;
  text-align: center;
  margin: 0;
}

.main2 {
  width: 2.32rem;
  height: 0.534rem;
  margin: 0.694rem 0 0 1.067rem;
}

.word6 {
  width: 0.747rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 16px;
  // font-family: PingFangSC-Medium;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: center;
}

.word7 {
  width: 1.44rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 0.3);
  font-size: 16px;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
}

.box3 {
  // width: 74%;
  flex: 3;
  margin: 0 20px;
  /* background: #ffffff; */
  /* border: 1px solid #e5e5e5; */
}

.main10 {
  /* width: 29.5rem; */
}

.mod2 {
  height: 1.014rem;
  width: 25.067rem;
  background: linear-gradient(18deg, #e4e4e2 0%, #f3f3f3 100%);
  padding: 0.24rem 0 0 0.507rem;
  margin: 0;
}

.info4 {
  width: 1.707rem;
  height: 0.587rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(43, 43, 43, 1);
  font-size: 0.426rem;
  // font-family: PingFangSC-Medium;
  white-space: nowrap;
  line-height: 0.587rem;
  text-align: center;
}

.mod3 {
  width: 8.4rem;
  height: 0.454rem;
  margin: 0.8rem 0 0 1.227rem;
  background: none;
}

.mod30 {
  /* width: 8.4rem;
  margin: 0.5rem 0 0 1.227rem; */
  background: none;
}

.line {
  background-color: #ebebeb;
  height: 20px;
  width: 1px;
  margin-left: 5px;
  margin-top: 3px;
}
.lineabsolute {
  position: absolute;
  left: 10px;
}

.word20 {
  border: 1px solid white;
  width: 80px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 15px;
  // font-family: PingFangTC-Medium;
  white-space: nowrap;
  font-weight: 600;
}

.mod7 {
  width: 24rem;
  height: 0.027rem;
  margin: 0.587rem 0 0 0.534rem;
  opacity: 0.09;
  border-bottom: 1px solid #262626;
}

.mod8 {
  padding: 4px 0px 4px 0px;
  width: 23.894rem;
  margin: 0rem 0 0 0.587rem;
}

.word32 {
  height: 0.454rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 16px;
  // font-family: PingFangTC-Medium;
  white-space: nowrap;
  line-height: 0.454rem;
  text-align: left;
  margin-left: 25px;
}

.bd2 {
  height: 25px;
  border-radius: 5px;
  border: 1px solid rgba(170, 29, 31, 1);
  background-color: rgba(255, 255, 255, 1);
  margin-left: 0.4rem;
  margin-top: 10px;
}

.main11 {
  height: 100%;
}

.word33 {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-wrap: break-word;
  color: rgba(170, 29, 31, 1);
  font-size: 16px;
  white-space: nowrap;
  padding: 0px 10px 0px 10px;
}

.group1 {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0 5px 5px 0;
  padding: 0px 3px 0px 3px;
  background-color: rgba(170, 29, 31, 1);
}

.label2 {
  width: 0.427rem;
  height: 0.427rem;
}

.img1 {
  width: 38.4rem;
  height: 11.44rem;
  margin-top: -11.814rem;
}

.bd3 {
  // position: relative;
  // z-index: 32;
  /* margin-left: 10.14rem; */
  margin-top: 3px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 5px 4px 0px rgba(232, 232, 232, 0.5);
  width: 100%;
  padding: 0 0.8rem;
  min-height: 60vh;
}

.box4 {
  width: 1500px;
  margin: 0 auto;
}
.pagetop {
  display: flex;
  .searchbox {
    padding-left: 10px;
    img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
    img:hover {
      cursor: pointer;
    }
    display: flex;
    align-items: center;
  }
}
.flexclass {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  // padding-top: 3px;
  // align-items: center;
  align-items: flex-end;
}

.contentbox {
  width: 100%;
  height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 100px;
}
.layer10 {
  // width: 100%;
  // margin-top: 0.774rem;
  flex-wrap: wrap;

  // flex: 1;

  // overflow: auto;
}

.main12 {
  // z-index: 35;
  border: 1px solid rgba(236, 236, 236, 1);
  background-color: rgba(255, 255, 255, 1);
  /* box-shadow: 0px 4px 0px 0px rgba(170, 29, 31, 1); */
  /* width: 5.554rem; */
  position: relative;
}

.box5 {
}

.bd4 {
  z-index: 40;
  position: relative;
  height: 5.3333rem;
  overflow: hidden;
  background-size: 5.654rem 3.36rem;
}

.layer11 {
  z-index: 41;
  left: 0;
  top: -0.56rem;
  height: 8.96rem;
  /*background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngc357bda3dce39199d6a17f07ddad0e9608fedeae5d69198a9652c8ebf6a2c56a)
    0rem 0.587rem no-repeat;*/
  background-size: 5.654rem 3.36rem;
}

.word34 {
  // width: 1.494rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 16px;
  font-weight: bold;
  // font-family: PingFangSC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  // margin: 0.4rem 0 0 0;
}

.info14 {
  // width: 2.24rem;
  // height: 0.454rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 0.49);
  font-size: 14px;
  // white-space: nowrap;
  line-height: 0.454rem;
  text-align: left;
  margin: 0.2rem 0 0 0;
  display: flex;
  padding: 0;

  .info141 {
    // width: 18%;
  }
  .info142 {
    // width: 82%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.info141 {
  font-weight: 600;
}

.txt13 {
  // display: block;
  color: rgba(38, 38, 38, 0.49);
  font-size: 14px;
  // font-family: PingFangTC-Regular;
  // text-align: left;
  margin: 0.2rem 0 0 0;
  display: flex;
  padding: 0;
  .tex131 {
    // width: 18%;
    font-weight: 600;
  }
  .tex132 {
    // width: 82%;
    text-align: justify;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* 显示的行数 */
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
  }
}
.bd5 {
  width: 2.774rem;
  // height: 0.56rem;
  margin: 10px 0 0 0;
}
.bd55 {
  margin-top: 10px;
}

.btngoto {
  cursor: pointer;
  width: 1.2rem;
  // height: 0.534rem;
  background: url("/static/icon/file.png") 0rem 0rem no-repeat;
  background-size: auto 0.4rem;
  background-position: 0 1px;

  text-align: right;
  font-size: 14px;
  color: #707070;
}

.section4 {
  width: 0.534rem;
  height: 0.534rem;
  background: url("../assets/img/icon_res_give.png") 0rem 0rem no-repeat;
  background-size: 0.56rem 0.534rem;
  margin-left: 0.187rem;
}

.section5 {
  width: 0.534rem;
  height: 0.534rem;
  background-color: rgba(0, 0, 0, 0);
}

.section6 {
  width: 0.534rem;
  height: 0.534rem;
  background-color: rgba(0, 0, 0, 0);
}

.wrap1 {
  width: 0.534rem;
  height: 0.534rem;
  background: url("../assets/img/icon_res_collect.png") -0.027rem -0.027rem
    no-repeat;
  background-size: 0.56rem 0.534rem;
}

.box6 {
  cursor: pointer;
  z-index: 63;
  width: 1.2rem;
  // height: 0.534rem;
  background: url(/static/icon/forward.png) 0rem 0rem no-repeat;
  background-size: auto 0.4rem;
}
.gnstyle {
  text-align: right;
  font-size: 14px;
  color: #707070;
}
.box66 {
  background: url("/static/icon/see.png") -0.01rem 0.1rem no-repeat;
  // background-size: 0.56rem 0.4rem;
  // width: 1.75rem;
  background-size: auto 0.45rem;
  background-position: 0;
  // width: 1.4rem;
}

.layer25 {
  margin-top: 30px;
  width: 100%;
}

.box21 {
  margin-top: 0.4rem;
  margin-bottom: 0.4rem;
  display: flex;
  align-items: center;
  overflow-wrap: break-word;
  white-space: nowrap;
  font-size: 0;
  justify-content: flex-end;
  padding-right: 10px;
  img {
    cursor: pointer;
  }
}

.txt18 {
  font-size: 16px;
  color: rgba(170, 29, 31, 1);
  line-height: 0.454rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.word60 {
  font-size: 16px;
  color: rgba(38, 38, 38, 1);
  line-height: 0.454rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.info24 {
  font-size: 16px;
  color: rgba(170, 29, 31, 1);
  line-height: 0.454rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.word61 {
  font-size: 16px;
  color: rgba(38, 38, 38, 1);
  line-height: 0.454rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-tree {
  min-width: 100%;
  display: inline-block;
}

.tree {
  overflow: auto;
  max-height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/pages/result_multiple.vue